var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._g(_vm._b({directives:[{name:"updateInput",rawName:"v-updateInput",value:(_vm._model),expression:"_model"}],staticClass:"form-control",class:_vm.classes,domProps:{"value":_vm._model}},'input',_vm.$attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }